import { Link, useNavigate } from 'react-router-dom'
import Header from '../../components/Header'
import Page from '../../components/Page'
import VideoForm from '../../components/VideoForm'
import { useCreateVideo } from '../../hooks/video'

export default function VideoCreate() {
  const createVideo = useCreateVideo()
  const navigate = useNavigate()

  return (
    <Page>
      <Header margins>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/video">Video</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Aggiungi
            </li>
          </ol>
        </nav>
      </Header>
      <div className="py-3 overflow-y-auto flex-1">
        <VideoForm
          save={async (video) => {
            const savedVideo = await createVideo.mutateAsync(video)
            navigate(`/video/${savedVideo.id}`)
          }}
        />
      </div>
    </Page>
  )
}
